import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=c10285fe&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=c10285fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10285fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c10285fe')) {
      api.createRecord('c10285fe', component.options)
    } else {
      api.reload('c10285fe', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=c10285fe&scoped=true&", function () {
      api.rerender('c10285fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8KWZhCM6oj2KV/JS/comp/Voucher.vue"
export default component.exports